import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { firebasePresenceInit } from "../utility/firebasePresence";

/* we reached this becuase we got a response from authContext already */
/* we either have currentUser or currentUser is null */

const PrivateRoute = (props) => {
  const { currentUser } = useAuth();

  useEffect(() => {
    firebasePresenceInit(currentUser?.uid);
  }, []);

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }
  return props.children;
};

export default PrivateRoute;
